module.exports = __webpack_public_path__ + "static/media/DSC_0059a.b74a7262.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/climb/DSC_0059a.JPG
// module id = 128
// module chunks = 0